import React from 'react';
import { Description } from './description';
import { DescriptionWithToggle } from './description-with-toggle';
import { useScreenBreakpoint } from 'consts/breakpoints';


interface DescriptionProps {
  description: string;
}

export const DescriptionWrapper: React.FC<DescriptionProps> = (props) => {
  const {
    description,
  } = props;

  const screenBreakpoint = useScreenBreakpoint();
  const isMobile = screenBreakpoint < 3;
  const maxDescriptionLength = isMobile ? 150 : 550;
  const isLong = description.length > maxDescriptionLength;

  return isLong ? <DescriptionWithToggle description={description} /> : <Description description={description} />;
};


export default React.memo(DescriptionWrapper);
